import ProxyBase from '../../../core/proxies/ProxyBase'

class AlertProxy extends ProxyBase {
  getAlertHighlight(params) {
    return this.post('Alert/AlertStatistic', params)
  }
  getAlertList(params) {
    return this.post('Alert/AlertList', params)
  }
  searchCompany(params) {
    return this.post('Alert/SearchCompany', params)
  }
  searchIndustry(params) {
    return this.post('Alert/SearchIndustry', params)
  }
  deleteAlert(params) {
    return this.delete('Alert/DeleteAlert', params)
  }
  markAsReadAlert(params) {
    return this.post('Alert/MarkAsRead', params)
  }
  markAsUnreadAlert(params) {
    return this.post('Alert/MarkAsUnRead', params)
  }
  updateAlertSettings(params) {
    return this.post('AlertSetting/update', params)
  }
  updateProfileSendEmail(params) {
    return this.post('AlertSetting/updateProfile', params)
  }
  deleteAlertProfile(params) {
    return this.delete('AlertSetting/deleteProfile', params)
  }
  getPortfolios(params) {
    return this.get('Library/SearchPortfolio', params)
  }
  getAlertDetails(params) {
    return this.get('Alert/AlertDetails', params)
  }
  getScoreRangesCreditRisk(params) {
    return this.get('Score/ScoreRangesCreditRisk', params)
  }
  getScoreRangesPerformance(params) {
    return this.get('Score/ScoreRangesPerformance', params)
  }
  getCompanyInfo(params) {
    return this.get('CompanyProfile/CompanyHeader', params)
  }
  getAlertCriteriaDynamic(params) {
    return this.get('AlertSetting/AlertCriteria', params)
  }
}

export default new AlertProxy()
